<template>
	<div>
		<h3>Projets</h3>

		<b-form v-on:submit.prevent="onSubmit">
			<b-container fluid>
				<b-row>
					<b-col cols="8"
						><b-form-select
							@change="onSubmit(true)"
							v-model="project"
							:options="projects_options"
							:value="project"
					/></b-col>
				</b-row>
			</b-container>
		</b-form>

		<br />

		<div v-if="render">
			<div v-for="month in Object.keys(months).sort().reverse()" :key="month">
				<div v-if="month != 'Invalid date'">
					<p style="font-weight:bold">{{month == "9999 12" ? "Global" : [month, "YYYY MM"] | moment('MMMM YYYY')}}</p>
					
					<div>Temps total: {{ (months[month].time >= 120) ? (months[month].time / 60).toFixed(0) + " minutes" : months[month].time + " seconde" + (months[month].time > 1 ? "s" : "") }}</div>
					<div>Nombre de traitements: {{ months[month].nb }}</div>
					<div v-for="(value, key) in months[month]" :key="key">
						<div v-if="key != 'time' && key != 'nb' && key != 'user' && key != 'users'">
							{{ key }}: {{ value }}
						</div>
					</div>

					<br />

					<b-table
						striped
						hover
						:items="months[month].users"
						:fields="fields"
						:sort-by.sync="sortBy"
						:sort-desc.sync="sortDesc"
						tbody-tr-class="rowClass">
						<template v-slot:cell(time)="data">
							{{ (data.value >= 120) ? (data.value / 60).toFixed(0) + " minutes" : data.value + " seconde" + (data.value > 1 ? "s" : "") }}
						</template>
						<template v-slot:cell(user)="data">
							{{ data.value ? data.value.prenom + " " + data.value.nom : "" }}
						</template>
					</b-table>
				</div>
			</div>
			<div v-if="Object.keys(months).length == 0">
				<p>Pas de traitements</p>
			</div>
		</div>
		<div v-else>
			Calcul en cours
		</div>
	</div>
</template>

<script>
	import treatments from "../services/treatments.js";
	import projects from "../services/projects.js";
	import store from "../store";
	import moment, { months } from "moment";

	require('moment/locale/fr')

	var clone = require("clone");

	export default {
		name: "project_stats",
		data() {
			return {
				sortBy: "time",
				sortDesc: true,
				project: null,
				list_projects: [],
				projects_options: [],
				if_prev: true,
				if_next: true,
				fields: [],
				treats: [],
				total: 0,
				months: {},
				obj_month: {},
				render: false
			};
		},
		methods: {
			onSubmit: async function (reset = false) {
				await this.getTreatments(this.project);
			},
			changeProject: async function () {},
            isAdmin: function() {
                return store.getters.isAdmin;
			},
			async getTreatmentsProjects(id_project, ofset, limit)
			{
				var treats = await treatments.getAllNoLimit(id_project, ofset, limit)
				var projects = treats["projects"];
				for (var i = 0; i < treats["users"].length; i++) {
					this.users[treats["users"][i]["uid"]] = treats["users"][i];
				}

				var nb_treats = 0;

				for (var i = 0; i < projects.length; i++) {
					if (projects[i]["traitements"]) 
					{
						nb_treats = projects[i]["traitements"].length;
						for (var j = 0; j < projects[i]["traitements"].length; j++)
					 	{
							var treat = projects[i]["traitements"][j];
							var date = moment(treat["dateheure_debut"]).format("YYYY MM")

							if (!this.obj_months["9999 12"])
							{
								this.obj_months["9999 12"] = { 
									time: 0, 
									nb: 0,
									users: {}
								};
							}
							if (!this.obj_months["9999 12"].users[treat.client_user_uid])
							{
								this.obj_months["9999 12"].users[treat.client_user_uid] = { 
									time: 0, 
									nb: 0
								};
							}

							if (!this.obj_months[date])
							{
								this.obj_months[date] = { 
									time: 0, 
									nb: 0,
									users: {}
								};
							}
							if (!this.obj_months[date].users[treat.client_user_uid])
							{
								this.obj_months[date].users[treat.client_user_uid] = { 
									time: 0, 
									nb: 0
								};
							}

							if (treat["dateheure_fin"])
							{
								treat.t = moment(treat["dateheure_fin"]).unix() - moment(treat["dateheure_debut"]).unix();

								if (treat.t >= 86400)
								{
									treat.t = 0;
									if (!treat.details)
										treat.details = {};
									if (!treat.details.meters)
										treat.details.meters = {};
									treat.details.meters["Plus de 1 jour"] = 1;
								}

								if (treat.details && treat.details.meters)
								{
									var keys = Object.keys(treat.details.meters);
									for (var k = 0; k < keys.length; k++)
									{
										if (!this.obj_months["9999 12"][keys[k]])
										{
											this.obj_months["9999 12"][keys[k]] = 0;
											this.fields.push({
												key: keys[k],
												label: keys[k]
											})
										}
										if (!this.obj_months[date][keys[k]])
											this.obj_months[date][keys[k]] = 0;
										if (!this.obj_months["9999 12"].users[treat.client_user_uid][keys[k]])
											this.obj_months["9999 12"].users[treat.client_user_uid][keys[k]] = 0;
										if (!this.obj_months[date].users[treat.client_user_uid][keys[k]])
											this.obj_months[date].users[treat.client_user_uid][keys[k]] = 0;
										this.obj_months["9999 12"][keys[k]] += treat.details.meters[keys[k]];
										this.obj_months[date][keys[k]] += treat.details.meters[keys[k]];
										this.obj_months["9999 12"].users[treat.client_user_uid][keys[k]] += treat.details.meters[keys[k]];
										this.obj_months[date].users[treat.client_user_uid][keys[k]] += treat.details.meters[keys[k]];
									}
								}

								this.obj_months["9999 12"].users[treat.client_user_uid].time += treat.t;
								this.obj_months["9999 12"].users[treat.client_user_uid].nb++;
								this.obj_months["9999 12"].time += treat.t;
								this.obj_months["9999 12"].nb++;

								this.obj_months[date].users[treat.client_user_uid].time += treat.t;
								this.obj_months[date].users[treat.client_user_uid].nb++;
								this.obj_months[date].time += treat.t;
								this.obj_months[date].nb++;
							}
						}
					}
				}

				return nb_treats;
			},
			getTreatments: async function (id_project) {
				try {
					this.treats = [];
					this.months = {};
					this.obj_months = {};
					this.users = {};
					this.render = false;

					this.fields = [{
						key: "user",
						label: "Utilisateur",
						sortable: true
					},
					{
						key: "time",
						label: "Temps",
						sortable: true
					},
					{
						key: "nb",
						label: "Nombre de traitements",
						sortable: true
					}]

					var list = [{uid: id_project}];
					if (id_project == null)
						list = this.list_projects;

					for (var i = 0; i < list.length; i++)
					{
						var c = true;
						var ofset = 0;
						var limit = 10000;
						while (c)
						{
							var size = await this.getTreatmentsProjects(list[i].uid, ofset, limit);
							console.log(list[i].uid + " : " + size)
							if (size >= limit)
								ofset++;
							else
								c = false;
						}
					}

					var keys_months = Object.keys(this.obj_months);
					for (var i = 0; i < keys_months.length; i++)
					{
						var treats = [];
						var keys = Object.keys(this.obj_months[keys_months[i]].users);
						for (var j = 0; j < keys.length; j++)
						{
							var obj = this.obj_months[keys_months[i]].users[keys[j]];
							obj.user = this.users[keys[j]];
							treats.push(obj)
						}
						this.obj_months[keys_months[i]].users = treats;
						this.months[keys_months[i]] = this.obj_months[keys_months[i]];
					}

					this.render = true;

				} catch (error) {
					console.log(error);
				}
			},
			getProjects: async function () {
				try {
					this.list_projects = await projects.getAll(false, true);
				} catch (error) {
					console.log(error);
				}
			},
		},
		created: async function () {
			
			if (store.state.user.rules && !store.state.user.rules.treatments_stats) {
				this.$router.push({ name: "profile" });
			}

			await this.getProjects();
			this.projects_options.push({
					value: null,
					text: "Tous les projets",
				});
			for (var i = 0; i < this.list_projects.length; i++) {
				this.projects_options.push({
					value: this.list_projects[i]["uid"],
					text: this.list_projects[i]["libelle"],
				});
			}

			if (this.projects_options.length > 1)
			{
				this.project = this.projects_options[1].value;

				await this.getTreatments(this.project);
			}
		},
	};
</script>

<style>
	.rowClass {
		background-color: pink;
	}
</style>
